import { BaseApi } from '@/main/baseApi';

import { NAME, MODULE_API, DependentTableNames, EmailAttachments } from './constants';

export class CommunicationEventConfigProvider extends BaseApi {
	constructor() {
		super(MODULE_API, NAME);
	}

	schemaUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case EmailAttachments:
				return `/${this.area}/${NAME}/EmailAttachmentsSchema`;
			default:
				throw new Error(`schema for ${tableName} is not implemented yet`);
		}
	}

	tableUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case EmailAttachments:
				return `/${this.area}/${NAME}/EmailAttachmentsRows`;
			default:
				throw new Error(`data for ${tableName} is not implemented yet`);
		}
	}

	tableSchemaDataUrl(tableName: string): string {
		switch (tableName) {
			case EmailAttachments:
				return `/${this.area}/${NAME}/EmailAttachmentsSchemaAndRows`;
			default:
				return super.tableSchemaDataUrl(tableName);
		}
	}

	saveCommunicationEventConfigData(dto: any) {
		return this.post(`/${MODULE_API}/${NAME}/SaveCommunicationEventConfig`, dto);
	}

	deleteCommunicationEventConfigData(id: null | number) {
		return this.delete(`/${MODULE_API}/${NAME}/DeleteCommunicationEventConfig`, id);
	}

	saveDocument(formData: FormData, id: null | number) {
		return this.uploadMultipart(`/${MODULE_API}/${NAME}/SaveCommEventAttachment?id=${id}`, formData);
	}

	deleteDocuments(fileId: number) {
		return this.delete(`/${MODULE_API}/${NAME}/DeleteCommEventAttachment?id=${fileId}`, fileId);
	}

	getDocuments(fileId: number) {
		return this.fetch(`/${MODULE_API}/${NAME}/GetCommEventAttachmentstDocument?id=${fileId}`);
	}
}

export const apiProvider = new CommunicationEventConfigProvider();
